import { isAfter, isBefore } from 'date-fns';

/**
 * Entity can either be ticketType or ticketGroup
 */
const handleDateTimeBased = ({ entity, now }) => {
  if (entity == null) return false;
  if (entity.saleStartOn == null && entity.saleEndOn == null) return false;

  const saleStartOn = entity.saleStartOn ? new Date(entity.saleStartOn) : null;
  const saleEndOn = entity.saleEndOn ? new Date(entity.saleEndOn) : null;

  const isAfterStart = saleStartOn ? isAfter(now, saleStartOn) : true;
  const isBeforeEnd = saleEndOn ? isBefore(now, saleEndOn) : true;

  return isAfterStart && isBeforeEnd;
};

export default handleDateTimeBased;
